module.exports = __webpack_public_path__ + "076310f1a07534efa4ecd9b0f7c9306b.png";